'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Thead_module = require('../styles/Thead.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Thead = (props) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Thead_module.default);
    return (React__namespace.createElement("thead", { className: cx(className, 'container'), ...restProps }, children));
};

exports.Thead = Thead;
//# sourceMappingURL=Thead.js.map
